

import QueryStatsIcon from '@mui/icons-material/QueryStats';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import SupervisorAccount from '@mui/icons-material/SupervisorAccount';
import GroupIcon from '@mui/icons-material/Group';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import SettingsIcon from '@mui/icons-material/Settings';
import PublicIcon from '@mui/icons-material/Public';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LinkIcon from '@mui/icons-material/Link';
import TokenIcon from '@mui/icons-material/Token';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import HandshakeIcon from '@mui/icons-material/Handshake';
import RedeemIcon from '@mui/icons-material/Redeem';
import PaidIcon from '@mui/icons-material/Paid';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

export const menuConfig = [
    {
        title: 'menu.dashboard',
        path: '/app/dashboard',
        icon: <QueryStatsIcon />
    },
    {
        title: 'pages.account.title',
        path: '/app/users',
        icon: <AccountBoxIcon />,
        sublistData: [
            {
                title: 'pages.users.title',
                icon: <SupervisorAccount />,
                controller: 'cabinet/users',
                path: '/app/users'
            },
            {
                title: 'pages.roles.title',
                icon: <GroupIcon />,
                controller: 'cabinet/roles',
                path: '/app/roles'
            },
            {
                title: 'pages.rolePermissions.title',
                icon: <WorkspacesIcon />,
                controller: 'cabinet/role-permissions',
                path: '/app/role-permissions'
            },
            {
                title: 'pages.rolesActionsPermissions.title',
                icon: <DisplaySettingsIcon />,
                controller: 'cabinet/roles-actions-permissions',
                path: '/app/roles-actions-permissions'
            }
        ]
    },
    {
        title: 'pages.wallet.title',
        icon: <AccountBalanceWalletIcon />,
        sublistData: [
            {
                title: 'pages.wallet-users.title',
                icon: <AccountBoxIcon />,
                controller: 'wallet/users',
                path: '/app/wallet-users'
            },
            {
                title: 'pages.wallet-users-kyc.title',
                icon: <SupervisorAccount />,
                controller: 'wallet/users-kyc',
                path: '/app/wallet-users-kyc'
            },
            {
                title: 'pages.wallet-pin-codes.title',
                icon: <DisplaySettingsIcon />,
                controller: 'wallet/pin-codes',
                path: '/app/wallet-pin-codes'
            },
            {
                title: 'pages.wallet-notifications.title',
                icon: <PublicIcon />,
                controller: 'wallet/notifications',
                path: '/app/wallet-notifications'
            },
            {
                title: 'pages.wallet-accounts.title',
                icon: <AccountBalanceIcon />,
                controller: 'wallet/accounts',
                path: '/app/wallet-accounts'
            },
            {
                title: 'pages.wallet-wallets.title',
                icon: <LinkIcon />,
                controller: 'wallet/wallets',
                path: '/app/wallet-wallets'
            },
            {
                title: 'pages.wallet-transfers.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'wallet/transfers',
                path: '/app/wallet-transfers'
            },
            {
                title: 'pages.wallet-events.title',
                icon: <FileCopyIcon />,
                controller: 'wallet/events',
                path: '/app/wallet-events'
            },
            {
                title: 'pages.crypto-topups.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'crypto/topups',
                path: '/app/crypto-topups'
            },
            {
                title: 'pages.crypto-withdrawals.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'crypto/withdrawals',
                path: '/app/crypto-withdrawals'
            }
        ]
    },
    {
        title: 'pages.accounting.title',
        icon: <AccountBalanceIcon />,
        sublistData: [
            {
                title: 'pages.accounting-system-accounts.title',
                icon: <AccountBalanceIcon />,
                controller: 'accounting/system-accounts',
                path: '/app/accounting-system-accounts'
            },
            {
                title: 'pages.accounting-crypto-collections.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'accounting/crypto-collections',
                path: '/app/accounting-crypto-collections'
            },
            {
                title: 'pages.accounting-system-transactions.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'accounting/system-transactions',
                path: '/app/accounting-system-transactions'
            },
            {
                title: 'pages.accounting-expenses-transactions.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'accounting/expenses-transactions',
                path: '/app/accounting-expenses-transactions'
            },
            {
                title: 'pages.accounting-revenue-transactions.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'accounting/revenue-transactions',
                path: '/app/accounting-revenue-transactions'
            }
        ]
    },
    {
        title: 'pages.partners.title',
        icon: <HandshakeIcon />,
        sublistData: [
            {
                title: 'pages.partners-referral-codes.title',
                icon: <QrCode2Icon />,
                controller: 'partners/referral-codes',
                path: '/app/partners-referral-codes'
            },
            {
                title: 'pages.partners-referrals.title',
                icon: <PeopleAltIcon />,
                controller: 'partners/referrals',
                path: '/app/partners-referrals'
            },
            {
                title: 'pages.partners-rewards.title',
                icon: <RedeemIcon />,
                controller: 'partners/rewards',
                path: '/app/partners-rewards'
            },
            {
                title: 'pages.partners-payouts.title',
                icon: <PaidIcon />,
                controller: 'partners/payouts',
                path: '/app/partners-payouts'
            }
        ]
    },
    {
        title: 'pages.settings.title',
        icon: <SettingsIcon />,
        sublistData: [
            {
                title: 'pages.publicCountries.title',
                icon: <PublicIcon />,
                controller: 'countries',
                path: '/app/countries'
            },
            {
                title: 'pages.currencies.title',
                icon: <CurrencyExchangeIcon />,
                controller: 'currencies',
                path: '/app/currencies'
            },
            {
                title: 'pages.banks.title',
                icon: <AccountBalanceIcon />,
                controller: 'banks',
                path: '/app/banks'
            },
            {
                title: 'pages.chains.title',
                icon: <LinkIcon />,
                controller: 'crypto/chains',
                path: '/app/chains'
            },
            {
                title: 'pages.cryptoTokens.title',
                icon: <TokenIcon />,
                controller: 'crypto/tokens',
                path: '/app/crypto-tokens'
            },
            {
                title: 'pages.exportCsvTasks.title',
                icon: <FileCopyIcon />,
                controller: 'export-tasks',
                path: '/app/export-csv-tasks'
            }
        ]
    },
];

